import { useEffect, useState } from "react";
import PricingModal from "@/components/PricingModal";
import DailyLimitModal from "@/components/DailyLimitModal";
import { api } from "@/lib/api";

/**
 * Mounted once at the app root. Two paywalls:
 *   - `oak:daily-limit` (axios 402 interceptor) → Out-of-Credits modal
 *     with the dynamic "Your next free credits arrive in X days" copy.
 *     Clicking Upgrade hands off to the PricingModal.
 *   - `oak:open-upgrade` (any direct CTA, e.g. Header "Upgrade") →
 *     PricingModal directly, no out-of-credits hop.
 * Single source of truth for both modals so we never double-mount.
 */
export default function DailyLimitGate() {
  const [pricingOpen, setPricingOpen] = useState(false);
  const [outOfCreditsOpen, setOutOfCreditsOpen] = useState(false);
  const [daysUntilReset, setDaysUntilReset] = useState(null);

  useEffect(() => {
    const onLimit = () => {
      // Pull the latest cycle metadata from the same balance endpoint the
      // header reads — keeps the countdown in sync without a separate API.
      api.get("/credits/balance")
        .then(({ data }) => setDaysUntilReset(
          typeof data?.days_until_reset === "number" ? data.days_until_reset : null
        ))
        .catch(() => setDaysUntilReset(null));
      setOutOfCreditsOpen(true);
    };
    const onUpgrade = () => setPricingOpen(true);
    window.addEventListener("oak:daily-limit", onLimit);
    window.addEventListener("oak:open-upgrade", onUpgrade);
    return () => {
      window.removeEventListener("oak:daily-limit", onLimit);
      window.removeEventListener("oak:open-upgrade", onUpgrade);
    };
  }, []);

  return (
    <>
      <DailyLimitModal
        open={outOfCreditsOpen}
        onOpenChange={setOutOfCreditsOpen}
        daysUntilReset={daysUntilReset}
        onOpenCheckout={() => setPricingOpen(true)}
      />
      <PricingModal open={pricingOpen} onOpenChange={setPricingOpen} />
    </>
  );
}
